import * as React from "react";
import qs from "qs";
import { SubNav } from "..";
import { BackLink } from "./components";

function AdminNavigation(props) {
  const { pathname, search } = props;
  const parsedQueryString = qs.parse(search, { ignoreQueryPrefix: true });
  const advisorId = parsedQueryString.fromAdvisor;

  const advisorLinkActive =
    pathname.includes("/Portal/admin/advisor") ||
    pathname.includes("/Portal/admin/household/") ||
    pathname.includes("/Portal/admin/portfolio/");

  return (
    <SubNav
      items={[
        {
          isAvailable: true,
          label: "Admin Dashboard",
          path: "/Portal/admin",
        },
        {
          isActive: advisorLinkActive,
          isAvailable: true,
          label: "Advisors",
          path: "/Portal/admin/advisor",
        },
        {
          isAvailable: true,
          label: "Custodians",
          path: "/Portal/admin/custodians",
        },
        {
          isAvailable: true,
          label: "Fees",
          path: "/Portal/admin/fees",
        },
      ]}
      suffix={<BackLink pathname={pathname} advisorId={advisorId} />}
      {...props}
    />
  );
}

export default AdminNavigation;



// WEBPACK FOOTER //
// ./src/containers/Cy/components/AdminNavigation/index.jsx